export default "__VITE_ASSET__C$WU9LoB__"